// Vendors
import React from 'react';
// Components
import { IconComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import { LANDING_OPTIONS_MODAL_CLOSE_COMPONENT_PROPS } from './constants/landing-options-modal-close.constants';
// Types
import { LandingOptionsModalComponentType } from '../../types/landing-options-modal.component.type';

const LandingOptionsModalCloseComponent = <T,>({
  onClose,
}: Pick<LandingOptionsModalComponentType<T>, 'onClose'>): React.JSX.Element => (
  <IconComponent {...LANDING_OPTIONS_MODAL_CLOSE_COMPONENT_PROPS} onClick={onClose} />
);

export { LandingOptionsModalCloseComponent };
